
import React from "react";
import ChatPage from "./ChatPage";

const Index: React.FC = () => {
  return <ChatPage />;
};

export default Index;
